module.exports = __webpack_public_path__ + "static/media/banner.aaae4ea3.jpg";